// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { commonEnvironment } from './environment.common';

const defaultEnvironmentConfig = {
  ...commonEnvironment, // add our common variables
  environmentName: 'Dev',
  production: false,
  hmr: false,
  mawaniURL: 'https://dev-accounts.dpworld.com/',
  clientId: 'CF',
  forgotURL: 'https://dev-accounts.dpworld.com/forgot-password/CF',
  mawaniDocumentUploadApiURL: 'https://api-accountsdev.dpworld.com/documentmanagement-api/documents',
  mawaniDocumentApiURL: 'https://api-accountsdev.dpworld.com/clientmanagement-api',
  mawaniReferentialApiURL: 'https://api-accountsdev.dpworld.com/referential-api/',
  companyReference: 'CFC00000001',
  serviceProviderCode: 'DTF',
  serviceProviderCodeCayman: 'DTFCM',
  locationCode: 'DTF',
  clientTypeCode: 'MS',
  requestDemoURL: 'https://test.freightrates.in/finance',
  enableGTAGID: true,
  clientRegistrationURL: 'https://dev-login.dpworld.com/auth/realms/dtworld/protocol/openid-connect/',
  clientRegistrationRedirectionURL: 'http://localhost:4200/',
  ndaRedirectionURL: 'https://demo.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=e3c17ebf-2fd0-4783-8aaa-3b859cc773a5&env=demo&acct=9e857184-8b35-4080-967d-683b463ad86d&v=2',
  accountingModuleRootUrl: 'https://dev-finance-accounting.dpworld.com/'
};

const dynamicEnvironmentConfig = {
  ...commonEnvironment,
  ...window['config']
};

export const environment = window['config'] ? dynamicEnvironmentConfig : defaultEnvironmentConfig;
